import axios from "axios";

const API_ENDPOINT = "auth";

export default {
    verify(user, query) {
        return axios.post(`${API_ENDPOINT}/email/verify/${user}?${query}`);
    },

    resend() {
        return axios.post(`${API_ENDPOINT}/email/resend`);
    },

    createUser(user) {
        return axios.post(`${API_ENDPOINT}/createUser`, user);
    },

    updateUser(user) {
        return axios.post(`${API_ENDPOINT}/updateUser`, user);
    },

    updateUserLogin(user) {
        return axios.post(`${API_ENDPOINT}/updateUserLogin`, user);
    },

    forgotPassword(forgotDetails) {
        return axios.post(`${API_ENDPOINT}/forgotPassword`, forgotDetails);
    },

    resetPassword(resetDetails) {
        return axios.post(`${API_ENDPOINT}/resetPassword`, resetDetails);
    },
};
